export default __webpack_public_path__ + "static/media/fvp3.a7ab2259.jpg";